module.exports = __webpack_public_path__ + "img/circles-right-form.a8c50dde.svg";